export default {
  toggleMenu({ state, commit }) {
    commit('setIsMenuOpen', !state.isMenuOpen)
  },
}
